import { LngLat } from 'mapbox-gl';
import { ImageAlignment } from 'records/MappedSheetVersion';

class MapboxRect {
  topLeft = new LngLat(0, 0);

  topRight = new LngLat(0, 0);

  bottomRight = new LngLat(0, 0);

  bottomLeft = new LngLat(0, 0);

  width = 0;

  height = 0;

  static fromCoordinateArray(
    coords: number[][],
    width: number,
    height: number
  ): MapboxRect {
    const rect = new MapboxRect();

    rect.topLeft = new LngLat(coords[0][0], coords[0][1]);
    rect.topRight = new LngLat(coords[1][0], coords[1][1]);
    rect.bottomRight = new LngLat(coords[2][0], coords[2][1]);
    rect.bottomLeft = new LngLat(coords[3][0], coords[3][1]);
    rect.width = width;
    rect.height = height;

    return rect;
  }

  static fromImageAlignment(
    imageAlignment: ImageAlignment,
    width: number,
    height: number
  ): MapboxRect {
    const rect = new MapboxRect();

    const { topleft, topright, bottomleft, bottomright } = imageAlignment;

    rect.topLeft = new LngLat(topleft.longitude, topleft.latitude);
    rect.topRight = new LngLat(topright.longitude, topright.latitude);
    rect.bottomRight = new LngLat(bottomright.longitude, bottomright.latitude);
    rect.bottomLeft = new LngLat(bottomleft.longitude, bottomleft.latitude);
    rect.width = width;
    rect.height = height;

    return rect;
  }

  toImageAlignment(): ImageAlignment {
    return {
      topleft: { longitude: this.topLeft.lng, latitude: this.topLeft.lat },
      topright: { longitude: this.topRight.lng, latitude: this.topRight.lat },
      bottomright: {
        longitude: this.bottomRight.lng,
        latitude: this.bottomRight.lat,
      },
      bottomleft: {
        longitude: this.bottomLeft.lng,
        latitude: this.bottomLeft.lat,
      },
    };
  }
}

export default MapboxRect;
